import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import SuggestedFilterChips from '@/common/SuggestedFilterChips';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useFreeTextSearchQuery } from '~/context/srp/InventoryContext';
import useSuggestedFilterChipItems from '~/hooks/srp/useSuggestedFilterChipItems';
import PopularVehicleStylesRow from './FreeTextNoResults/PopularVehicleStylesRow';
import RecentlyViewedCarousel from './FreeTextNoResults/RecentlyViewedCarousel';
import SuggestedForYouCarousel from './FreeTextNoResults/SuggestedForYouCarousel';

export default function FreeTextNoResultsSection() {
  const freeTextSearchQuery = useFreeTextSearchQuery();
  const { isLoading, items, showCounts, showSuggestedFilters } =
    useSuggestedFilterChipItems();
  const trackEvent = useTrackEvent();

  useEffect(() => {
    trackEvent('Free Text No Results Shown');

    datadogRum.addAction('Free Text No Results Shown');
  }, [trackEvent]);

  return (
    <div className="flex min-w-0 flex-col gap-4xl lg:gap-7xl">
      <div
        className="mt-4xl flex flex-col items-center gap-lg text-center"
        data-testid="free-text-no-results-message"
      >
        <div className="text-text-strong t-heading-lg sm:t-heading-xl">
          We didn’t find results for “{freeTextSearchQuery}”
        </div>
        <div className="text-text-default t-body-sm">
          Try a different search or explore other options.
        </div>
      </div>
      {showSuggestedFilters && (isLoading || items.length > 0) && (
        <div className="flex flex-wrap gap-md">
          <SuggestedFilterChips
            isLoading={isLoading}
            items={items}
            showCounts={showCounts}
          />
        </div>
      )}
      <SuggestedForYouCarousel />
      <RecentlyViewedCarousel />
      <PopularVehicleStylesRow />
    </div>
  );
}
